import React, { useMemo, useState, useEffect } from 'react'

import PageHeader from '../components/PageHeader'
import Filters from '../components/Filters'
import TabNav from '../components/TabNav'
import EventsTable from '../components/EventsTable'
import SelectedEventCard from '../components/SelectedEventCard'
//import NotificationsPanel from '../components/NotificationsPanel'
//import { demoEvents, demoNotifications, sports } from '../../../utils/demoData'
import { sports } from '../../../utils/demoData'
import goalResultService from '../../../services/goalResultService'
import { LoadingSpinner } from '../../../components'
import { useWindowWidth } from '@react-hook/window-size';
import { useSessionStorage } from '../../../hooks/useSessionStorage'

const sorting = [
  { name: 'By League', id : "league" },
  { name: 'By Event Time', id: "time" }
]

const LiveEventControlPage = () => {
  const onlyWidth = useWindowWidth();
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10))
  const [sport, setSport] = useState('All Sports')
  const [tab, setTab] = useState("All");
  const [eventList, setEventList] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sortType, setSortType] = useState(sorting[0]);
  const [showOddsDetails, setShowOddsDetails] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

 const { readSession } = useSessionStorage();
 const userDetails = useMemo(() => readSession('userDetails', null), [readSession])

 const filtered = useMemo(() => {
  const normalisedSearch = searchTerm.trim().toLowerCase()

  return eventList
    .filter(e => sport === "All Sports" || e.sport === sport)
    .filter(e => tab === "All" || e.status === tab)
    .filter(e => {
      if (!normalisedSearch) return true
      return [
        e.eventId,
        e.rapidEventId,
        e.homeTeam,
        e.awayTeam,
        e.homeName,
        e.awayName,
        e.hname,
        e.aname,
        e.leagueName,
        e.league,
        e.sport,
        e.status,
      ]
        .filter(value => value !== null && value !== undefined)
        .some(value => String(value).toLowerCase().includes(normalisedSearch))
    })
    .sort((a, b) => {
      if (sortType.id === "league") {
        return a.leagueName.localeCompare(b.leagueName); // ✅ Proper string sorting
      } else {
        return new Date(a.eventTime) - new Date(b.eventTime); // ✅ Ensure proper date sorting
      }
    });
}, [sport, tab, eventList, sortType, searchTerm]);


  useEffect(() => {
    if (filtered.length > 0) {
      setSelectedId(prev => prev ?? filtered[0].eventId);
    } else {
      setSelectedId(null);
    }
  }, [filtered]);

  const selected = useMemo(
    () => filtered.find(e => e.eventId === selectedId) || filtered[0] || null,
    [filtered, selectedId]
  );

  const fetchResultWithOdds = async () => {
    try {
      setIsLoading(true);
      const response = await goalResultService.getResultWithOdds(date);
      if (response.status === 200) {
        setEventList(response.data.payload);
      }
    } catch (error) {
      console.error("Failed to fetch result hub data", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchResultWithOdds();
     // eslint-disable-next-line
  }, []);

  if (isLoading) {
    return <LoadingSpinner />
  }

  const handleSearch = async() => {
    fetchResultWithOdds();
  }

  return (
    <div className="min-h-screen w-full dark:bg-custom_dark_background bg-customLightMilkWhite text-customWhite font-inter">
      <div className="mx-auto max-w-[1400px] p-2">
        <PageHeader title="Event Control" />

        <div className="mt-1 flex flex-col gap-4 lg:flex-row">
          <div className="flex-1">
            <div className="shadow-lg rounded-md dark:bg-custom_dark_primary2/60 p-2 ring-1 dark:ring-custom_dark_secondary/50 bg-customLightMilkWhite ring-customForeColor/10">
              <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                <Filters
                  date={date}
                  onDateChange={setDate}
                  sport={sport}
                  sortType={sortType}
                  onSportChange={setSport}
                  values = {sorting}
                  setSortType = {setSortType}
                  isMobile={onlyWidth < 768}
                  sports={["All Sports", ...sports]}
                  handleSearch={handleSearch}
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  showOddsDetails={showOddsDetails}
                  onToggleOddsDetails={setShowOddsDetails}
                />
                <TabNav tabs={["All", "Upcoming", "Finished", "Postponed"]} active={tab} onChange={setTab} isMobile={onlyWidth < 768}/>
              </div>

              <div className="mt-2 grid grid-cols-1 gap-4 lg:grid-cols-3">
                <div className="lg:col-span-2">
                  <EventsTable
                    rows={filtered}
                    selectedId={selected?.eventId}
                    onSelect={setSelectedId}
                    isMobile={onlyWidth < 768}
                    showOddsDetails={showOddsDetails}
                  />
                </div>
                <div>
                  <SelectedEventCard event={selected} isMobile={onlyWidth < 768} userDetails={userDetails} setEventList={setEventList}/>
                </div>
              </div>
            </div>

            {/* <div className="mt-6">
              <NotificationsPanel notifications={demoNotifications} />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LiveEventControlPage
